/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Project_File_TitleInputs */



/**
* | output |
* | --- |
* | "Project File" |
*
* @param {File_Export_Project_File_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_project_file_title = /** @type {((inputs?: File_Export_Project_File_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Project_File_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo do projeto")
	return /** @type {LocalizedString} */ ("Project File")
});